import React, { useEffect } from "react";
import { useCaptcha } from "@repoflow/components/captcha";
import * as CaptchaLib from "@repoflow/browser/captcha";
import { Icon as LoadingIcon } from "@repoflow/components/loading";
import * as ParamsLib from "@repoflow/browser/params";
import * as Loading from "@repoflow/components/loading";

import { useMutation, gql } from "@apollo/client";
import { Container, Col, Row, Alert } from "reactstrap";
import { basename } from "env";

const MUTATION = gql`
  mutation Validate($validation: String!, $token: String!) {
    viewer {
      anonymous(token: $token) {
        auth {
          validate(validation: $validation) {
              id
              email
              status
              domain
              domainId
              orgId
              token
          }
        }
      }
    }
  }
`;

export default () => {
  const validation = ParamsLib.urlParameter("token");
  const domain = ParamsLib.urlParameter("domain");


  if (!validation && domain) {
    return (
      <Container>
        <Row className="mt-4">
          <Col>
            <p>You need to access the link on your notification email to validate your sign up on <b>{domain}</b></p>
            <p>Please review your email and click on the validation link.</p>
          </Col>
        </Row>
      </Container>
    );
  }
  else
    if (validation) {
      return (
        <Validate validation={validation} />
      );
    } else {
      return "Invalid request"
    }


};



const Validate = ({ validation }) => {
  const { publicKey, ready } = useCaptcha();

  const [handler, { error: mutationError }] =
    useMutation(MUTATION, {
      refetchQueries: [],
      onCompleted: (data) => {
        const user = data.viewer.anonymous.auth.validate
        if (user) {
          const {status, domain, orgId, domainId, token} = user;
          const info = new URLSearchParams({ domain, orgId, domainId }).toString();
          if (status === 'unattached') {
            window.location = `${basename}/auth/attach?token=${encodeURIComponent(token)}&${info}`;
          }
          else {
            window.location = `${basename}/auth/login?${info}`;
          }
        }
      },
      onError: (error) => {
        console.log(error);
      },
    });

  useEffect(() => {
    if (ready) {
      CaptchaLib.request(publicKey, (token) => {
        handler({
          variables: {
            validation,
            token,
          },
        });
      });
    }
  }, [ready]);

  if (!ready) {
    return <Loading.Content />;
  }

  return (
    <Container>
      <Row className="mt-4">
        <Col>
          {!mutationError ? (
            <Alert color="info">
              Validating your account... <LoadingIcon />
            </Alert>
          ) : (
            <Alert color="danger">
              We could not validate your account. This link may have already
              been used or expired — please contact support.
            </Alert>
          )}
        </Col>
      </Row>
    </Container>
  );
};